
import { AppBoot } from "@/AppBoot";
AppBoot.start();
